import { z } from 'zod';
import { IdSchema, InstantSchema } from '../common/index.js';

/**
 * Comptes rendus d'entretien et d'appel (réunion du 16/10 #31, RG-26, statut STA-09), ajout PARITE-4 au contrat 1.0.0.
 * Internes au cabinet (audience « staff » seulement) : jamais transmis à un héritier, un mandant, une clerc ou un notaire.
 * Cycle : à faire → à relire (généré depuis le texte de l'entretien, toujours « à vérifier », RG-19) → validé (figé).
 */
export const CompteRenduKindSchema = z.enum(['entretien', 'appel']).meta({ id: 'CompteRenduKind' });
export const CompteRenduStatusSchema = z.enum(['a_faire', 'a_relire', 'valide']).meta({ id: 'CompteRenduStatus' });

const Titre = z.string().trim().min(1).max(200);
const TexteSource = z.string().trim().min(1).max(20_000);

export const CompteRenduSchema = z
  .object({
    id: IdSchema,
    dossierId: IdSchema,
    personId: IdSchema.nullable(),
    kind: CompteRenduKindSchema,
    title: z.string().min(1),
    status: CompteRenduStatusSchema,
    sourceText: z.string().nullable(),
    body: z.string().nullable(),
    createdAt: InstantSchema,
    createdByDisplayName: z.string(),
    generatedAt: InstantSchema.nullable(),
    validatedAt: InstantSchema.nullable(),
    validatedByDisplayName: z.string().nullable(),
    rowVersion: z.number().int().min(1),
  })
  .meta({ id: 'CompteRendu', description: 'Compte rendu d’entretien ou d’appel, interne au cabinet.' });

export const CompteRenduCreateSchema = z
  .object({
    kind: CompteRenduKindSchema,
    title: Titre,
    personId: IdSchema.nullable().optional(),
    sourceText: TexteSource.optional(),
  })
  .meta({ id: 'CompteRenduCreate', description: 'Compte rendu à faire ; le texte de l’entretien peut venir plus tard.' });

export const CompteRenduGenerationSchema = z
  .object({ sourceText: TexteSource.optional() })
  .meta({ id: 'CompteRenduGeneration', description: 'Texte de l’entretien collé ; sans lui, celui déjà enregistré.' });

export const CompteRenduPatchSchema = z
  .object({ body: z.string().trim().min(1).max(50_000) })
  .meta({ id: 'CompteRenduPatch', description: 'Correction du texte généré, avant validation.' });

export const CompteRenduValidationSchema = z
  .object({ rowVersion: z.number().int().min(1) })
  .meta({ id: 'CompteRenduValidation', description: 'Version lue : on ne valide que le texte relu.' });

export const CompteRenduATraiterSchema = CompteRenduSchema.extend({
  dossierReference: z.string().min(1),
  dossierTitle: z.string().min(1),
}).meta({ id: 'CompteRenduATraiter' });

export const ComptesRendusATraiterSchema = z
  .object({
    aFaire: z.array(CompteRenduATraiterSchema),
    aRelire: z.array(CompteRenduATraiterSchema),
    valides: z.array(CompteRenduATraiterSchema),
  })
  .meta({ id: 'ComptesRendusATraiter', description: 'Carte du Pilotage : à faire, à relire, derniers validés, tous dossiers.' });
